import React, { useContext } from "react";
import { TipWrapper, MainTitle, SubTitle } from "./styled";
import { AppContext } from "@/Context";
import {
  page1mainTitleChange,
  page1AddrChange,
  page1TimeChange,
  page1SubtitleChange
} from "@/common/store/action.index.js";
import { contentEditing } from "@/common/store/action.js";
const LargeBanner = props => {
  const { state, dispatch } = useContext(AppContext);
  const tempMode = state.tempMode;
  const maintitle = state.pages[0] && state.pages[0][0].content;
  const timeInfo = state.pages[0] && state.pages[0][1].content;
  const addrInfo = state.pages[0] && state.pages[0][2].content;
  const subtitle = state.pages[0] && state.pages[0][3].content;

  const hookMainContentEditing = content => {
    dispatch(page1mainTitleChange(content));
  };
  const hookSubContentEditing = content => {
    dispatch(page1SubtitleChange(content));
  };
  const hookTimeContentEditing = content => {
    dispatch(page1TimeChange(content));
  };
  const hookAddrContentEditing = content => {
    dispatch(page1AddrChange(content));
  };

  return (
    <TipWrapper {...props}>
      <MainTitle
        className={tempMode === "edit" && "edit-mode"}
        onClick={() => {
          if (tempMode === "edit") {
            dispatch(
              contentEditing(true, {
                content: maintitle,
                maxLength: 11
              })
            );
            AppContext.hook = hookMainContentEditing;
          }
        }}
      >
        {maintitle}
      </MainTitle>
      <p
        className={
          tempMode === "edit" ? "detail-info edit-mode" : "detail-info"
        }
        onClick={() => {
          if (tempMode === "edit") {
            dispatch(
              contentEditing({
                type: "textarea"
              }, {
                content: timeInfo,
                maxLength: 40
              })
            );
            AppContext.hook = hookTimeContentEditing;
          }
        }}
      >
        {timeInfo}
      </p>
      <p
        className={
          tempMode === "edit" ? "detail-info edit-mode" : "detail-info"
        }
        onClick={() => {
          if (tempMode === "edit") {
            dispatch(
              contentEditing({
                type: "textarea"
              }, {
                content: addrInfo,
                maxLength: 40
              })
            );
            AppContext.hook = hookAddrContentEditing;
          }
        }}
      >
        {addrInfo}
      </p>
      <SubTitle
        className={tempMode === "edit" && "edit-mode"}
        onClick={() => {
          if (tempMode === "edit") {
            dispatch(
              contentEditing(true, {
                content: subtitle,
                maxLength: 24
              })
            );
            AppContext.hook = hookSubContentEditing;
          }
        }}
      >
        {subtitle}
      </SubTitle>
    </TipWrapper>
  );
};
export default LargeBanner;
